import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
// import "./../../Products/Faq/Faq.css";
import AskFaq from "./../../../../Images/askFaq.png";
function EtfFAQ() {
  return (
    <>
      <section className="faq-block">
        <Container>
          <Row>
            <Col md={8}>
              <h1>Frequently Asked Questions</h1>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Q1. What is an ETF?</Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                      An ETF, also known as an exchange-traded fund is a pooled
                      investment of assets that functions similarly to a mutual
                      fund. Unlike mutual funds, ETF typically track a specific
                      index, sector, commodity, etc. ETF prices reflect the Net
                      asset value (NAV) of the basket in which it invests. These
                      funds are passively managed and are listed and traded on
                      stock exchanges.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                  Q2. How can I buy/sell ETF through Moneysukh?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <ul>
                      {/* <li>Visit trade.moneysukh.com and login through your Moneysukh User ID & password.</li> */}
                      <li>Visit <a href="https://online.moneysukh.com" target="_blank">https://online.moneysukh.com</a> and login with your Moneysukh User ID & password.</li>
                      <li>Search for the ETF you wish to buy/sell. </li>
                      <li>You must ensure that you have sufficient funds to buy that security</li>
                      <li>Hover over the security and Tap on buy/sell. Fill in the necessary details like price, quantity, etc.</li>
                      <li>Conclude the transaction.</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Q3. Where can I check performance of ETF?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <ul>
                      {/* <li> Visit trade.moneysukh.com and login through your Moneysukh User ID & password.</li> */}
                      <li>Visit <a href="https://online.moneysukh.com" target="_blank">https://online.moneysukh.com</a> and login with your Moneysukh User ID & password.</li>
                      <li>Search for and choose the ETF whose performance you want to examine.</li>
                      <li>Hover the cursor over the ETF and click the info button.</li>
                      <li>The data will begin to appear on the right side.</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Q4. How ETF are different from Mutual funds?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                      In many ways, ETF are like mutual funds, except that ETF
                      are purchased and sold on the stock exchange from existing
                      buyers, whereas mutual funds are purchased and sold, from
                      and to the issuer on the closing price at the end of the
                      day. Mutual funds seek alpha by outperforming a market
                      benchmark, whereas ETF track and replicate the returns of
                      the relevant index.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    Q5. What are the upsides of exchange-traded funds (ETF)?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <ul className="upsides-list">
                      <li>
                        <span>Way to diversify Portfolio</span>
                      </li>
                      <li>
                        <span>Low cost</span>
                      </li>
                      <li>
                        <span>Transparent </span>
                      </li>
                      <li>
                        <span>Tax efficient</span>
                      </li>
                      <li>
                        <span>Easy to trade</span>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
            <Col md={4}>
              <div className="faq-beta">
                <img className="img-fluid" src={AskFaq} alt={AskFaq} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default EtfFAQ;
